import CountryForm from '$blocks/Country/Form'
import { DEFAULT_FORM_VALUES } from '$blocks/Country/Form/constants'

const CountryCreate = () => {
  return <CountryForm defaultValues={DEFAULT_FORM_VALUES} />
}

export default CountryCreate
